import React from "react";
import { observer, inject } from "mobx-react";
import { withRouter } from "react-router-dom";
import { Helmet } from "react-helmet-async";
import Container from "reactstrap/lib/Container";
import queryString from "query-string";
import orderBy from "lodash/orderBy";
import { graphql } from "@apollo/client/react/hoc";
import { PROVIDERS_LIST_QUERY } from "Services/queries";
import withDefaultParams from "Services/withDefaultParams";
import { generateUrl } from "Services/withDefaultParams";
import configRouters from "Configs/routes";
import { isMoscowSiteCode } from "Utils/siteConfig";
import SeoBlockHOC from "HOC/SeoBlockHOC";
import Districts from "Containers/DistrictsContainer";
import DeclinationContainerNew from "Containers/DeclinationContainerNew";
import TopProviderContainer from "Containers/TopProviderContainer";
import { SeoBlockContainer } from "Containers/SeoBlock";
import { AddressAdverBlockContainer } from "Containers/AdBlocksContainer";
import { PaddingBottom } from "ComponentsUI/Spacings";
import { Redirect404, RedirectPagination } from "ComponentsUI/Redirects";
import ListOfProvidersWithInjectedTariffs from "ComponentsUI/ListOfProvidersWithInjectedTariffs";
import Stub from "./Stub";
import FiltersContainer from "../Containers/Filters";
import PaginationContainer from "../Containers/PaginationContainer";
import AddressSearchContainer from "Containers/AddressSearchContainer";
import Metrika from "Services/Metrika";

let LIMIT = 35;

@inject("ApplicationModel")
@observer
class Page extends React.Component {
	static defaultProps = {
		onProviderSelect: () => {},
		onProviderConnect: () => {},
		onProviderReviews: () => {},
	};

	canonical() {
		const {
			ApplicationModel: { siteConfig },
		} = this.props;

		const location = generateUrl(configRouters.Providers.route, {
			regionUrl: this.props.match.params.regionUrl,
		});

		return (
			<Helmet>
				<link
					rel="canonical"
					href={`${siteConfig.ssl === true ? `https` : "http"}://${
						siteConfig.domain_name_full
					}${location}`}
				/>
			</Helmet>
		);
	}

	handleChoose(value) {
		if (value === "home") {
			Metrika.getInstance().google.sendEvent(
				EVENT_CATEGORY_CLICK_BUTTON,
				EVENT_ACTION_CLICK_FLAT_BUTTON
			);
		} else {
			Metrika.getInstance().google.sendEvent(
				EVENT_CATEGORY_CLICK_BUTTON,
				EVENT_ACTION_CLICK_OFFICE_BUTTON
			);
		}
	}

	render() {
		const route = this.props.route;
		if (this.props.data.loading && !this.props.data.providers) return <Stub />;
		let page = 1;
		if (this.props.match.params.page > -1) {
			page = parseInt(this.props.match.params.page);
		}

		if (this.props.match.params.page === "1") {
			return <RedirectPagination />;
		}

		if (!page || this.props.data.providers.pagination.items_total < LIMIT * (page - 1)) {
			return <Redirect404 message404={"Выбрана пагинация больше доступной у списка провайдеров"} />;
		}

		let {
			ApplicationModel: { windowSizeModel, ratesModel, text },
			data: {
				providers: { data, pagination },
				providersAggregate: { aggregation },
			},
			location: { search },
			siteConfig,
		} = this.props;

		let providers = JSON.parse(JSON.stringify(data));
		providers.map((provider) => {
			provider.linkProviderSelect = generateUrl(configRouters.ProviderDetails.route, {
				providerName: provider.url_name,
				regionUrl: provider.region.url,
			});

			provider.linkProviderReviews = generateUrl(configRouters.ProvidersReviewListOld.route, {
				regionUrl: provider.region.url,
				providerName: provider.url_name,
			});
			provider.linkProviderConnect = generateUrl(configRouters.OrderHome.route, {
				regionUrl: provider.region.url,
			});
		});

		const params = queryString.parse(search);

		if (!params.sort) {
			const providersVipTariffs = providers.filter((x) => x.vip_provider && x.info.cnt_tariffs);
			const providersVipNoTariffs = providers.filter((x) => x.vip_provider && !x.info.cnt_tariffs);
			const providersNoVipTariffs = providers.filter((x) => !x.vip_provider && x.info.cnt_tariffs);
			const providersNoVipNoTariffs = providers.filter(
				(x) => !x.vip_provider && !x.info.cnt_tariffs
			);

			providers = providersVipTariffs.concat(
				providersVipNoTariffs,
				providersNoVipTariffs,
				providersNoVipNoTariffs
			);
		}

		let sortedAggregation = {};
		for (let it in aggregation) {
			sortedAggregation[it] = orderBy(aggregation[it], "name", "asc");
		}
		let showNewViewSearch = siteConfig?.settings?.show_new_view_search;

		return (
			<>
				{this.canonical()}

				<SeoBlockHOC route={route} placeText="AddressSearch">
					<AddressSearchContainer
						callback={(value) => this.handleChoose(value)}
						sendGAWhenFulled={true}
						showNewViewSearch={showNewViewSearch}
						buttonName="найти"
					/>
				</SeoBlockHOC>

				<Container>
					<SeoBlockContainer route={route} placeText="SeoBlock1" bgText={true} />
				</Container>

				<SeoBlockHOC route={route} placeText="TopProvider">
					<TopProviderContainer backgroundNone={true} />
				</SeoBlockHOC>

				<FiltersContainer aggregation={sortedAggregation} />

				<PaddingBottom>
					<ListOfProvidersWithInjectedTariffs
						hideProviderLogo={true}
						text={text}
						windowSize={windowSizeModel.windowSizes}
						items={providers}
						flat={ratesModel.orientation}
						yandexEvent={"providers.impressions_vip"}
						pageName="catalog_prov"
						onProviderConnect={this.props.onProviderConnect}
						onProviderRates={this.props.onProviderRates}
						onProviderSelect={this.props.onProviderSelect}
						onProviderReviews={this.props.onProviderReviews}
					/>
				</PaddingBottom>

				<PaginationContainer key={3} pagination={pagination} />

				<Container>
					<SeoBlockContainer route={route} placeText="SeoBlock2" bgText={true} />
				</Container>

				<AddressAdverBlockContainer autoExpansion={!showNewViewSearch} />

				<Container>
					<SeoBlockContainer route={route} placeText="SeoBlock3" bgText={true} />
				</Container>

				<SeoBlockHOC route={route} placeText="TopProvider">
					<TopProviderContainer backgroundNone={true} />
				</SeoBlockHOC>

				<Container>
					<SeoBlockContainer route={route} placeText="SeoBlock4" bgText={true} />

					<DeclinationContainerNew>
						<Districts />
					</DeclinationContainerNew>
				</Container>
			</>
		);
	}
}

export default withRouter(
	inject("ApplicationModel")(
		withDefaultParams(
			graphql(PROVIDERS_LIST_QUERY, {
				skip: (ownProps) => {
					return ownProps.match.params.regionUrl ? false : true;
				},
				options: (props) => {
					let page = 1;
					let random = true;
					if (props.match.params.page) {
						page = props.match.params.page;
					}
					let sort = "-vip_provider,vip_b2c_priority,-rating.expert.final,name";
					let filters = [];
					let aggregateFilter = [];
					let params = queryString.parse(props.location.search);

					if (params.sort) {
						sort = params.sort;
						random = false;
					}

					if (params.providers) {
						filters.push(`id=${params.providers}`);
					}

					if (params.service) {
						filters.push(`order_types.id=${params.service}`);
						if (!params.providers) {
							aggregateFilter.push(`order_types.id=${params.service}`);
						}
					}

					if (params.dody) {
						filters.push(`dody.global_id=${params.dody}`);
						if (!params.providers) {
							aggregateFilter.push(`dody.global_id=${params.dody}`);
						}
					}

					if (props.match.params.regionUrl) {
						filters.push(`region.url=${props.match.params.regionUrl}`);
						aggregateFilter.push(`region.url=${props.match.params.regionUrl}`);
					}
					if (isMoscowSiteCode(props.ApplicationModel.siteCode)) {
						LIMIT = 20;
					}
					return {
						variables: {
							filter: filters.join("&"),
							aggregateFilter: aggregateFilter.join("&"),
							limit: LIMIT,
							offset: page > 0 ? LIMIT * (page - 1) : 0,
							sort: sort,
							random,
						},
					};
				},
			})(Page)
		)
	)
);
